import { mapGetters } from "vuex";

export const getCatValues = {
  computed: {
    ...mapGetters(["loading", "categoryValue"])
  },
  methods: {
    catValueList: function(catName) {
      if (this.categoryValue.length !== 0) {
        return this.categoryValue.edges
          .filter(category => category.node.category)
          .filter(category =>
            category.node.category.catName.match(new RegExp(catName))
          );
      }
      return [];
    },
    catValueListArray: function(catName) {
      if (this.catValueList.length !== 0) {
        return this.catValueList(catName).map(item => item.node.valName);
      }
      return [];
    }
  }
};
